import * as utilityService from 'services/utilityService';
import { useMutation } from "react-query";
import { ContactUsDto } from 'types/dto';
import { RequestDemoDto } from 'types/dto/RequestDemoDto';

const contactUs = async (dto: ContactUsDto) => {
  return await utilityService.contactUs(dto);
}

const requestDemo = async (dto: RequestDemoDto) => {
  return await utilityService.requestDemo(dto);
}

// **********************************************************************
// **********************************************************************

export const useContactUs = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(contactUs, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useRequestDemo = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(requestDemo, {
    onSuccess,
    onError,
    ...options,
  });
}